module.exports = __webpack_public_path__ + "static/media/YF58_3.b3f36a7a.jpg";